import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { PageHero, Section, SectionHeading, PrimaryButton, SecondaryButton } from "@/components/ui-helpers";
import PackagesComparison from "@/components/PackagesComparison";

export default function Packages() {
  return (
    <>
      <SEO title="Packages" description="Ascendia Essential, Deep and Detail. Tailored quotes based on size, condition, location and scope." />
      <PageHero kicker="Packages" title="Choose your level of finish" subtitle="Property conditions vary, so we tailor every quote. These service levels show what's included at each tier.">
        <PrimaryButton to="/property-intelligence">Build your Property Plan <ArrowRight className="h-4 w-4" /></PrimaryButton>
        <SecondaryButton to="/contact">Get a Tailored Package</SecondaryButton>
      </PageHero>
      <Section>
        <Reveal><PackagesComparison /></Reveal>
        <p className="mt-6 text-sm text-muted-c">Pricing is tailored based on size, condition, location and scope. <Link to="/property-intelligence" className="text-gold-soft hover:text-gold">Build your Property Intelligence profile</Link> for an exact scope and estimated range, or send photos for the most accurate quote.</p>
      </Section>
    </>
  );
}
